import { IS_NATIVE_APP } from '../config/environment'
import {
	getNativeSecureItem,
	removeNativeSecureItem,
	setNativeSecureItem,
} from './nativeSecureStorage'

const NATIVE_SESSION_KEY = 'native-session'

let cachedToken: string | null | undefined

/** Reads the native bearer token from memory or the device keychain. */
export async function getNativeSessionToken(): Promise<string | null> {
	if (!IS_NATIVE_APP) return null
	if (typeof cachedToken !== 'undefined') return cachedToken

	cachedToken = await getNativeSecureItem(NATIVE_SESSION_KEY)
	return cachedToken
}

/** Persists a native bearer token in this device's keychain only. */
export async function setNativeSessionToken(token: string): Promise<void> {
	if (!IS_NATIVE_APP) {
		throw new Error(
			'Native session tokens cannot be stored in a web build.',
		)
	}
	await setNativeSecureItem(NATIVE_SESSION_KEY, token)
	cachedToken = token
}

/** Removes the native bearer token from memory and the device keychain. */
export async function clearNativeSessionToken(): Promise<void> {
	cachedToken = null
	if (!IS_NATIVE_APP) return

	try {
		await removeNativeSecureItem(NATIVE_SESSION_KEY)
	} catch (error) {
		// A storage failure must not prevent local logout or auth-failure recovery.
		console.error('Failed to remove the native session token:', error)
	}
}
